import {getListButtonStyle, getComponentConfig} from '../../selectors/settings'
import {hasEventDetailsUrl, isEventRestricted} from '../../selectors/events'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {RsvpButton as RsvpButtonPresentation} from './rsvp-button'
import {ButtonOwnProps, ButtonStateProps} from './interfaces'

const mapRuntime = ({state, actions}: AppProps, {event}: ButtonOwnProps): ButtonStateProps => ({
  navigateToPage: () => actions.navigateToPage(event),
  style: getListButtonStyle(getComponentConfig(state)),
  hasUrl: hasEventDetailsUrl(state, event),
  settings: getComponentConfig(state).settings,
  ensureLoginAndNavigateToPage: () => actions.ensureLoginAndNavigateToPage(event),
  eventRestricted: isEventRestricted(state, event),
})

export const RsvpButton = connect<ButtonOwnProps, ButtonStateProps>(mapRuntime)(RsvpButtonPresentation)

export * from './interfaces'
